import React, { useState, useEffect } from "react";
import axios from 'axios'
import toast from "react-hot-toast";
import { FaSearch, FaUserCheck } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { CgDanger } from "react-icons/cg";
import { MdDeleteForever } from "react-icons/md";


function DriverEnquiry({ userData, token }) {
  const navigate = useNavigate();


  const location = useLocation();
  const dealer = location.state?.dealer;

  const [searchTerm, setSearchTerm] = useState('');
  const [list, setList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showMachineModal, setShowMachineModal] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState(null);

  const [showPayModal, setShowPayModal] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [showCancelRefund, setShowCancelRefund] = useState(false);
  const [remark, setRemark] = useState("");

  const [showCloseModal, setShowCloseModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDelete, setSelectedDelete] = useState(null);

  const fetchDriverEnquiry = async () => {
    try {
      const res = await axios.get(`https://api.krimotion.in/fetch-driver-enquiry/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setList(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDriverEnquiry();

  }, []);

  const handleDriverPayment = async () => {
    try {
      const res = await axios.put(
        `https://api.krimotion.in/update-driver-payment/${selectedDriver.id}`,
        {
          d_pay_status: "Success",
          d_paid_on: new Date().toISOString().slice(0, 19).replace("T", " ")
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setShowPayModal(false);
      setSelectedDriver(null);
      fetchDriverEnquiry();

      toast.success("Payment marked as Success!");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update payment");
    }
  };

  const handleRefund = async () => {
    try {
      const res = await axios.put(
        `https://api.krimotion.in/update-refund/${selectedDriver.id}`,
        {
          customer_id:selectedDriver.customer_id,
          enquire_status: "Refund Completed",
          refund_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Refund completed successfully.");

      setShowRefundModal(false);
      setSelectedDriver(null);
      fetchDriverEnquiry();
    } catch (err) {
      console.error(err);
      toast.error("Failed to process refund.");
    }
  };


  const handleCancelRefund = async () => {
    if (!remark.trim()) {
      toast.warning("Please enter remark.");
      return;
    }

    try {
      const res = await axios.put(
        `https://api.krimotion.in/cancel-refund/${selectedDriver.id}`,
        {
           customer_id:selectedDriver.customer_id,
          enquire_status: "Refund Cancelled",
          rejected_on: new Date().toISOString().slice(0, 19).replace("T", " "),
          rej_remark: remark,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Refund cancelled successfully.");

      setShowRefundModal(false);
      setSelectedDriver(null);
      fetchDriverEnquiry();
    } catch (err) {
      console.error(err);
      toast.error("Failed to process refund.");
    }
  };


  const handleCloseEnquiry = async () => {
  
      try {
      const res = await axios.put(
        `https://api.krimotion.in/close-enquiry/${selectedData.id}`,
        {
          enquire_status: "Closed",
          rejected_on: new Date().toISOString().slice(0, 19).replace("T", " "),
     
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Enquiry closed successfully.");

     setShowCloseModal(false);
    setSelectedData(null);
      fetchDriverEnquiry();
    } catch (err) {
      console.error(err);
      toast.error("Failed to close enquiry.");
        setShowCloseModal(false);
    }
};

 const handleDeleteEnquiry = async () => {
  try {
    const res = await axios.delete(
      `https://api.krimotion.in/delete-vehicle-enquiry/${selectedDelete.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success(res.data.message);

    setShowDeleteModal(false);
    setSelectedDelete(null);

   fetchDriverEnquiry();
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};


  const filteredData = Array.isArray(list)
    ? list.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];

    const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; 
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

  return (
    <>
      <div className="container py-4">
        <div className="border-0  mb-3 px-2 py-2  ">

          <div className="d-flex flex-column gap-2">

            {/* TOP ROW: Title + Search */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

              <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                Driver Enquiry History
              </h4>

              <div style={{ flex: 1, maxWidth: "250px" }}>
                <div
                  className="d-flex align-items-center rounded-pill overflow-hidden"
                  style={{
                    border: "1px solid var(--green)",
                    height: "34px",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    backgroundColor: "white"
                  }}
                >
                  <FaSearch style={{ color: "var(--green)", fontSize: "14px" }} />

                  <input
                    type="text"
                    className="form-control border-0 shadow-none"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      fontSize: "14px",
                      height: "32px",
                      marginLeft: "6px"
                    }}
                  />
                </div>
              </div>

            </div>

            {/* SECOND ROW: Back Button */}
            <div>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => navigate(-1)}
              >
                ← Back
              </button>
            </div>

          </div>


        </div>
        <h5>
          <span className="status-badge status-success px-3 py-2">
            {dealer.machine_name}
          </span>
        </h5>

        {/* {!showForm && (
          <>
            <div className="card shadow-lg border-0 rounded-4 mt-4 overflow-hidden " style={{ background: '#f4f6f9' }}>

              <div className="card-body p-3">
                <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0 text-center">
                    <thead  >
                      <tr>


                        <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Cusotmer Name</th>
                        <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Driver Name</th>

                        <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Enquiry Status </th>
                        <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Created On </th>
                        <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Amount </th>
                        <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Pay Mode </th>

                        <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Pay Status </th>

                        <th className=" text-center text-white" style={{ backgroundColor: 'var(--green)' }}>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((dealer, index) => (
                          <tr key={index}>

                            <td>{dealer.cust_name}</td>
                            <td>{dealer.d_name}</td>
                            <td>{dealer.enquire_status}</td>
                            <td>{formatDate(dealer.enquire_on)} </td>
                            <td>{dealer.amount}</td>
                            <td>{dealer.pay_mode} </td>
                            <td>{dealer.pay_status} </td>



                            <td>
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                <button
                                  className="btn-action btn-primary-custom"
                                  onClick={() => {
                                    setSelectedData(dealer);
                                    setShowViewModal(true);
                                  }}
                                >
                                  <i className="bi bi-eye me-1"></i>
                                  Details
                                </button>


                                {(
                                  dealer.enquire_status === "Refund Request" ||
                                  dealer.enquire_status === "Refund Completed" ||
                                  dealer.enquire_status === "Refund Cancelled"
                                ) ? (

                                  <button
                                    className={`btn-action ${dealer.enquire_status === "Refund Completed"
                                        ? "btn-success-custom"
                                        : dealer.enquire_status === "Refund Cancelled"
                                          ? "btn-danger-custom"
                                          : "btn-warning-custom"
                                      }`}
                                    onClick={() => {
                                      setSelectedDriver(dealer);
                                      setShowRefundModal(true);
                                    }}
                                    disabled={
                                      dealer.enquire_status === "Refund Completed" ||
                                      dealer.enquire_status === "Refund Cancelled"
                                    }
                                  >
                                    {dealer.enquire_status === "Refund Completed" ? (
                                      <>
                                        <i className="bi bi-check-circle me-1"></i>
                                        Refunded
                                      </>
                                    ) : dealer.enquire_status === "Refund Cancelled" ? (
                                      <>
                                        <i className="bi bi-x-circle me-1"></i>
                                        Rejected
                                      </>
                                    ) : (
                                      <>
                                        <i className="bi bi-arrow-counterclockwise me-1"></i>
                                        Refund
                                      </>
                                    )}
                                  </button>

                                )
                                  : null

                                }

{dealer.enquire_status == "Accepted" &&(
  <>
  <button className="btn-action btn-danger-custom"
  onClick={() => {
      setSelectedData(dealer);
      setShowCloseModal(true);
    }}
  >
Closed
  </button>
  </>
)}

  <MdDeleteForever
  size={24}
  title="Delete Enquiry"
  className="text-danger"
  style={{ cursor: "pointer" }}
  onClick={() => {
    setSelectedDelete(dealer);
    setShowDeleteModal(true);
  }}
/>


                              </div>
                            </td>

                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center py-4">
                            No List Found
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>
                </div>
              </div>


            </div>

          </>
        )} */}
{!showForm && (
  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((dealer, index) => (
          <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

            <div className="inventory-card d-flex flex-column h-100">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-start">

                <div>
                  <h5 className="inventory-title mb-1">
                    {dealer.cust_name}
                  </h5>
                
                  <span className="badge bg-primary">
                  {dealer.enquire_status}
                  </span>
                </div>

                <h5 className="text-success fw-bold">
                  ₹ {dealer.amount}
                </h5>

              </div>

              <hr />

              {/* Details */}

              <div className="inventory-row">
                <span className="inventory-label">
                  Driver
                </span>

                <span>{dealer.d_name}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Created On
                </span>

                <span>{formatDate(dealer.enquire_on)}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Payment Mode
                </span>

                <span>{dealer.pay_mode}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Payment Status
                </span>

                <span>{dealer.pay_status}</span>
              </div>

                  <div className="inventory-row">
                <span className="inventory-label">
                  Enquiry Status
                </span>

                <span>{dealer.enquire_status}</span>
              </div>

              {/* Buttons */}

              <div className="mt-auto pt-3">

                <div className="d-flex flex-wrap gap-2">

                  <button
                    className="btn-action btn-primary-custom"
                    onClick={() => {
                      setSelectedData(dealer);
                      setShowViewModal(true);
                    }}
                  >
                    <i className="bi bi-eye me-1"></i>
                    Details
                  </button>

                  {(dealer.enquire_status === "Refund Request" ||
                    dealer.enquire_status === "Refund Completed" ||
                    dealer.enquire_status === "Refund Cancelled") && (

                    <button
                      className={`btn-action ${
                        dealer.enquire_status === "Refund Completed"
                          ? "btn-success-custom"
                          : dealer.enquire_status === "Refund Cancelled"
                          ? "btn-danger-custom"
                          : "btn-warning-custom"
                      }`}
                      onClick={() => {
                        setSelectedDriver(dealer);
                        setShowRefundModal(true);
                      }}
                      disabled={
                        dealer.enquire_status === "Refund Completed" ||
                        dealer.enquire_status === "Refund Cancelled"
                      }
                    >
                      {dealer.enquire_status === "Refund Completed"
                        ? "Refunded"
                        : dealer.enquire_status === "Refund Cancelled"
                        ? "Rejected"
                        : "Refund"}
                    </button>
                  )}

                  {dealer.enquire_status === "Accepted" && (
                    <button
                      className="btn-action btn-danger-custom"
                      onClick={() => {
                        setSelectedData(dealer);
                        setShowCloseModal(true);
                      }}
                    >
                      Closed
                    </button>
                  )}

                  <button
                    className="btn-action btn-secondary-custom"
                    onClick={() => {
                      setSelectedDelete(dealer);
                      setShowDeleteModal(true);
                    }}
                  >
                    <MdDeleteForever className="me-1" />
                    Delete
                  </button>


                                               <button
  className="btn-action btn-success-custom"
  onClick={() =>
    navigate("/admin/chat-history", {
      state: {
        dealer: dealer,
        enq_type:"Vehicle", 
      },
    })
  }
>
  View Chat
</button>

                </div>

              </div>

            </div>

          </div>
        ))
      ) : (
        <div className="col-12">
          <div className="text-center py-5">
            <h5>No List Found</h5>
          </div>
        </div>
      )}

    </div>
  </div>
)}


                      {showViewModal && (
                <div
                  className="modal d-block"
                  style={{
                    background: "rgba(15, 23, 42, 0.6)",
                    backdropFilter: "blur(6px)",
                    zIndex: 9999,
                  }}
                >
                  <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">

                    <div className="modal-content border-0 rounded-4 shadow-lg overflow-hidden">

                      {/* HEADER */}
                      <div className="modal-header bg-dark text-white py-3">
                        <div>
                          <h5 className="mb-0 fw-bold">Booking Details</h5>
                          {/* <small className="text-white-50">
                       ID: #{selectedData?.id || "N/A"}
                     </small> */}
                        </div>

                        <button
                          className="btn-close btn-close-white"
                          onClick={() => {
                            setShowViewModal(false);
                            setSelectedData(null);
                          }}
                        />
                      </div>

                      {/* BODY */}
                      <div className="modal-body p-2 bg-light">

                        {/* MACHINE CARD */}
                        <div className="card border-0 shadow-sm mb-3 rounded-3">
                          <div className="card-body">

                            <h6 className="fw-bold text-primary mb-3">
                              🚜 Machine Details
                            </h6>

                            <div className="row g-2">
                              <div className="col-md-6">
                                <small className="text-muted">Machine Name</small>
                                <div className="fw-semibold">{selectedData?.machine_name}</div>
                              </div>

                              <div className="col-md-6">
                                <small className="text-muted">Enquire On</small>
                                <div className="fw-semibold">{selectedData?.enquire_on}</div>
                              </div>
                            </div>

                          </div>
                        </div>

                        {/* CUSTOMER CARD */}
                        <div className="card border-0 shadow-sm mb-3 rounded-3">
                          <div className="card-body">

                            <h6 className="fw-bold text-success mb-3">
                              👤 Customer Details
                            </h6>

                            <div className="row">
                              <div className="col-md-6">
                                <small className="text-muted">Customer Name</small>
                                <div className="fw-semibold">{selectedData?.cust_name}</div>
                              </div>

                              <div className="col-md-6">
                                <small className="text-muted">Customer Mobile</small>
                                <div className="fw-semibold">{selectedData?.cust_mobile}</div>
                              </div>


                            </div>



                          </div>
                        </div>

                        {/* DRIVER CARD */}
                        <div className="card border-0 shadow-sm mb-3 rounded-3">
                          <div className="card-body">

                            <h6 className="fw-bold text-warning mb-3">
                              🚗 Driver Details
                            </h6>

                            <div className="row">
                              <div className="col-md-6">
                                <small className="text-muted">Driver Name</small>
                                <div className="fw-semibold">{selectedData?.d_name}</div>
                              </div>

                              <div className="col-md-6">
                                <small className="text-muted">Driver Mobile</small>
                                <div className="fw-semibold">{selectedData?.mobile}</div>
                              </div>

                              <div className="col-md-6">
                                <small className="text-muted">Arrival Date</small>
                                <div className="fw-semibold">{selectedData?.driver_date}</div>
                              </div>
                            </div>

                          </div>
                        </div>

                        {/* PAYMENT CARD */}
                        <div className="card border-0 shadow-sm mb-3 rounded-3">
                          <div className="card-body">

                            <h6 className="fw-bold text-primary mb-3">
                              💰 Payment Details
                            </h6>

                            <div className="row g-2">

                              <div className="col-md-6">
                                <small className="text-muted">Payment Mode</small>
                                <div className="fw-semibold">
                                  {selectedData?.pay_mode}
                                </div>
                              </div>

                              <div className="col-md-6 d-flex flex-column">
                                <small className="text-muted mb-1">Payment Status</small>

                                <span
                                  className={`badge px-3 py-2 w-fit ${selectedData?.pay_status === "Success"
                                      ? "bg-success"
                                      : "bg-warning text-dark"
                                    }`}
                                  style={{ width: "fit-content" }}
                                >
                                  {selectedData?.pay_status}
                                </span>
                              </div>

                              <div className="col-md-6">
                                <small className="text-muted">Payment ID</small>
                                <div className="fw-semibold">{selectedData?.pay_id}</div>
                              </div>

                              <div className="col-md-6">
                                <small className="text-muted">Payment Date</small>
                                <div className="fw-semibold">{selectedData?.advance_date}</div>
                              </div>

                            </div>

                          </div>
                        </div>

                        {/* Driver payment detail */}
                        <div className="card border-0 shadow-sm rounded-3">
                          <div className="card-body">

                            <h6 className="fw-bold text-danger mb-3">
                              💰Driver Payment Details
                            </h6>

                            <div className="row g-2">


                              <div className="col-md-6 d-flex flex-column">
                                <small className="text-muted mb-1">Payment Status</small>

                                <span
                                  className={`badge px-3 py-2 w-fit ${selectedData?.d_pay_status === "Success"
                                      ? "bg-success"
                                      : "bg-warning text-dark"
                                    }`}
                                  style={{ width: "fit-content" }}
                                >
                                  {selectedData?.d_pay_status}
                                </span>
                              </div>


                              <div className="col-md-6">
                                <small className="text-muted">Payment date</small>
                                <div className="fw-semibold">
                                  {selectedData?.d_paid_on}
                                </div>
                              </div>
                              <hr />

                              {selectedData?.enquire_status == 'Refund Request' && (
                                <>
                                  <div className="col-md-6">
                                    <small className="text-dark">Rejected By</small>
                                    <div className="fw-semibold">
                                      {selectedData?.rejected_by}
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <small className="text-dark">Reject date</small>
                                    <div className="fw-semibold">
                                      {selectedData?.rejected_on}
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <small className="text-dark">Remark</small>
                                    <div className="fw-semibold">
                                      {selectedData?.rej_remark}
                                    </div>
                                  </div>
                                </>

                              )}


   

                            </div>

                          </div>
                        </div>

                      </div>

                      {/* FOOTER */}
                      <div className="modal-footer bg-white border-0">
                        <button
                          className="btn btn-outline-secondary px-2"
                          onClick={() => {
                            setShowViewModal(false);
                            setSelectedData(null);
                          }}
                        >
                          Close
                        </button>
                      </div>

                    </div>

                  </div>
                </div>
              )}

              {showPayModal && (
                <div
                  className="modal d-block"
                  style={{
                    background: "rgba(0,0,0,0.55)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                  }}
                >
                  <div className="modal-dialog modal-dialog-centered">

                    <div
                      className="modal-content border-0 shadow-lg"
                      style={{ borderRadius: "18px", overflow: "hidden" }}
                    >

                      {/* HEADER */}
                      <div
                        className="text-center py-4"
                        style={{
                          background: "linear-gradient(135deg,#f59e0b,#f97316)",
                        }}
                      >

                        <div
                          className="mx-auto d-flex align-items-center justify-content-center"
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",
                            background: "rgba(255,255,255,0.2)",
                          }}
                        >
                          <FaUserCheck size={34} color="#fff" />
                        </div>

                        <h4 className="text-white fw-bold mt-3 mb-0">
                          Confirm Driver Payment
                        </h4>

                      </div>

                      {/* BODY */}
                      <div className="p-4 text-center">

                        <h5 className="fw-bold mb-2">
                          {selectedDriver?.d_name}
                        </h5>

                        <p className="text-muted mb-4">
                          Are you sure you want to mark this payment as{" "}
                          <strong>SUCCESS</strong>?
                        </p>

                        {/* STATUS BOX */}
                        <div
                          className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
                          style={{
                            background: "#fef3c7",
                          }}
                        >
                          <span className="me-2 fw-semibold text-dark">
                            Current Status
                          </span>

                          <span className="badge bg-warning text-dark">
                            {selectedDriver?.d_pay_status || "Pending"}
                          </span>


                        </div>

                      </div>

                      {/* FOOTER */}
                      <div className="px-4 pb-4 d-flex gap-3">

                        <button
                          className="btn btn-light border w-50"
                          style={{ borderRadius: "10px" }}
                          onClick={() => setShowPayModal(false)}
                        >
                          Cancel
                        </button>

                        <button
                          className="btn btn-success w-50"
                          style={{
                            borderRadius: "10px",
                            fontWeight: 600,
                          }}
                          onClick={handleDriverPayment}
                        >
                          <i className="bi bi-check-circle me-1"></i>
                          Confirm Payment
                        </button>

                      </div>

                    </div>
                  </div>
                </div>
              )}

              {showRefundModal && (
                <div
                  className="modal d-block"
                  style={{
                    background: "rgba(0,0,0,0.55)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                  }}
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div
                      className="modal-content border-0 shadow-lg"
                      style={{
                        borderRadius: "18px",
                        overflow: "hidden",
                      }}
                    >
                      {/* Header */}
                      <div
                        className="position-relative text-center py-4"
                        style={{
                          background: "linear-gradient(135deg,#dc3545,#ef4444)",
                        }}
                      >

                        <button
                          className="btn btn-sm btn-light position-absolute"
                          style={{
                            top: 15,
                            right: 15,
                            width: 35,
                            height: 35,
                            borderRadius: "50%",
                          }}
                          onClick={() => {
                            setShowRefundModal(false);
                            setShowCancelRefund(false);
                            setRemark("");
                          }}
                        >
                          ✕
                        </button>

                        <div
                          className="mx-auto d-flex align-items-center justify-content-center"
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",
                            background: "rgba(255,255,255,.2)",
                          }}
                        >
                          <FaUserCheck size={34} color="#fff" />
                        </div>

                        <h4 className="text-white fw-bold mt-3">
                          Confirm Refund
                        </h4>
                      </div>

                      {/* Body */}
                      <div className="p-4 text-center">
                        <h5 className="fw-bold">
                          {selectedDriver?.cust_name}
                        </h5>

                        <p className="text-muted">
                          Are you sure you want to refund this booking?
                        </p>

                        <div
                          className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
                          style={{
                            background: "#fee2e2",
                          }}
                        >
                          <span className="fw-semibold me-2">
                            Current Status
                          </span>

                          <span className="badge bg-warning text-dark">
                            {selectedDriver?.enquire_status}
                          </span>


                        </div>

                        <p className="fw-bold mt-3">
                          Refund Amount : ₹
                          {(Number(selectedDriver?.amount || 0) - Number(selectedDriver?.platform_fee || 0)).toFixed(2)}
                        </p>

                        {/* Show Remark Box */}
                        {showCancelRefund && (
                          <div className="mt-4 text-start">
                            <label className="form-label fw-semibold">
                              Cancellation Remark
                            </label>

                            <textarea
                              className="form-control"
                              rows={4}
                              placeholder="Enter cancellation remark..."
                              value={remark}
                              onChange={(e) => setRemark(e.target.value)}
                            />
                          </div>
                        )}
                      </div>

                      {/* Footer */}
                      <div className="px-4 pb-4">
                        {!showCancelRefund ? (
                          <div className="d-flex gap-3">
                            <button
                              className="btn btn-danger w-50"
                              onClick={handleRefund}
                            >
                              Confirm Refund
                            </button>

                            <button
                              className="btn btn-outline-secondary w-50"
                              onClick={() => setShowCancelRefund(true)}
                            >
                              Cancel Refund
                            </button>
                          </div>
                        ) : (
                          <div className="d-flex gap-3">
                            <button
                              className="btn btn-secondary w-50"
                              onClick={() => {
                                setShowCancelRefund(false);
                                setRemark("");
                              }}
                            >
                              Back
                            </button>

                            <button
                              className="btn btn-danger w-50"
                              onClick={handleCancelRefund}
                            >
                              Cancel This Refund
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {showCloseModal && (
  <div
    className="modal d-block"
    style={{
      background: "rgba(0,0,0,0.55)",
      backdropFilter: "blur(4px)",
      zIndex: 9999,
    }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div
        className="modal-content border-0 shadow-lg"
        style={{
          borderRadius: "18px",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          className="text-center py-4"
          style={{
            background: "linear-gradient(135deg,#dc3545,#b91c1c)",
          }}
        >
          <div
            className="mx-auto d-flex align-items-center justify-content-center"
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
            }}
          >
           
            <CgDanger  style={{ fontSize: "34px",color:'white' }} />
          </div>

          <h4 className="text-white fw-bold mt-3 mb-0">
            Close Enquiry
          </h4>
        </div>

        {/* Body */}
        <div className="p-4 text-center">
          <h5 className="fw-bold mb-2">
            {selectedData?.name}
          </h5>

          <p className="text-muted mb-4">
            Are you sure you want to <strong>close this enquiry</strong>?
            <br />
            This action will mark the enquiry as closed and it will no longer
            be available for assignment.
          </p>

          <div
            className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
            style={{
              background: "#fde8e8",
            }}
          >
            <span className="me-2 fw-semibold text-dark">
              Current Status
            </span>

            <span className="badge bg-success">
              {selectedData?.enquire_status}
            </span>
          </div>
        </div>

        {/* Footer */}
        <div className="px-4 pb-4 d-flex gap-3">
          <button
            className="btn btn-light border w-50"
            style={{ borderRadius: "10px" }}
            onClick={() => setShowCloseModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger w-50"
            style={{
              borderRadius: "10px",
              fontWeight: 600,
            }}
            onClick={handleCloseEnquiry}
          >
            <i className="bi bi-lock-fill me-2"></i>
            Yes, Close Enquiry
          </button>
        </div>
      </div>
    </div>
  </div>
)}


                                    {showDeleteModal && (
  <>
    <div
      className="modal-backdrop fade show"
      onClick={() => {
    setShowDeleteModal(false);
    setSelectedDelete(null);
  }}
    ></div>

    <div className="modal fade show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content border-0 shadow-lg"
          style={{ borderRadius: "16px" }}
        >
       
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title fw-bold">
              🗑 Delete Enquiry
            </h5>

            <button
              className="btn-close btn-close-white"
              onClick={() => setShowDeleteModal(false)}
            ></button>
          </div>

      
          <div className="modal-body text-center py-4">

            <div style={{ fontSize: "60px" }}>⚠️</div>

            <h5 className="mt-3 fw-bold">
              Are you sure?
            </h5>

            <p className="text-muted mb-0">
              You are about to permanently delete this enquiry.
            </p>

            <h6 className="fw-bold text-dark mt-2">
  {selectedDelete?.cust_name}
</h6>

            <p className="text-danger fw-semibold mt-2">
              This action cannot be undone.
            </p>

          </div>

       
          <div className="modal-footer border-0 justify-content-center">

            <button
              className="btn btn-outline-secondary px-4"
            onClick={() => {
    setShowDeleteModal(false);
    setSelectedDelete(null);
  }}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger px-4"
              onClick={handleDeleteEnquiry}
            >
              🗑 Delete
            </button>

          </div>

        </div>
      </div>
    </div>
  </>
)} 
      </div>
    </>
  )
}

export default DriverEnquiry
